import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    d="M7.85948 15.0001H6.17777L3.69135 11.2666V15.0001H2.00001V9.00012H3.69135L6.17295 12.7336V10.8669V9.00012H7.85948V15.0001Z"
  />,
  <path
    key="2"
    d="M13.5962 12.4575H10.9364V13.8875H14.0781V15.0001H9.24501V9.00012H14.0878V10.1169H10.9364V11.382H13.5962V12.4575Z"
  />,
  <path
    key="3"
    d="M20.5184 12.7625L21.3231 9.00012H23L21.511 15.0001H19.7571L18.8174 11.5798L17.8971 15.0001H16.1479L14.6541 9.00012H16.3358L17.1405 12.7625L18.1043 9.00012H19.5402L20.5184 12.7625Z"
  />,
  <path
    key="4"
    d="M10.8719 4.13764L12 3.39474L13.1281 4.13764C13.6682 4.49327 14.3087 4.6649 14.9542 4.62693L16.3026 4.54763L16.9082 5.75507C17.1981 6.33308 17.422 6.71024 18 7.00012H21.5C21.5235 6.60123 21.2948 6.38396 20.9376 6.20483L19.1416 5.30407C18.9489 5.20745 18.7926 5.05115 18.696 4.85848L17.7952 3.0624C17.6161 2.70522 17.2415 2.48896 16.8426 2.51242L14.8368 2.63038C14.6216 2.64304 14.4081 2.58583 14.2281 2.46729L12.55 1.36221C12.2163 1.14245 11.7837 1.14245 11.45 1.36221L9.7719 2.46729C9.59189 2.58583 9.37838 2.64304 9.16321 2.63038L7.15739 2.51242C6.75849 2.48896 6.38392 2.70522 6.20479 3.0624L5.30404 4.85848C5.20741 5.05115 5.05112 5.20745 4.85844 5.30407L3.06236 6.20483C2.70518 6.38396 2.47653 6.60123 2.49999 7.00012H5.99999C6.57801 6.71024 6.80193 6.33308 7.09181 5.75507L7.69735 4.54763L9.04579 4.62693C9.69131 4.6649 10.3318 4.49327 10.8719 4.13764Z"
  />,
  <path
    key="5"
    d="M7.09181 18.245C6.80193 17.667 6.57801 17.29 5.99999 17.0001H2.49999C2.47653 17.399 2.70518 17.6161 3.06236 17.7952L4.85844 18.696C5.05112 18.7926 5.20741 18.9489 5.30404 19.1416L6.20479 20.9377C6.38392 21.2949 6.75849 21.5111 7.15738 21.4877L9.16321 21.3697C9.37838 21.357 9.59189 21.4142 9.7719 21.5328L11.45 22.6379C11.7837 22.8576 12.2163 22.8576 12.55 22.6379L14.2281 21.5328C14.4081 21.4142 14.6216 21.357 14.8368 21.3697L16.8426 21.4877C17.2415 21.5111 17.6161 21.2949 17.7952 20.9377L18.696 19.1416C18.7926 18.9489 18.9489 18.7926 19.1416 18.696L20.9376 17.7952C21.2948 17.6161 21.5235 17.399 21.5 17.0001H18C17.422 17.29 17.1981 17.667 16.9082 18.245L16.3026 19.4524L14.9542 19.3731C14.3087 19.3352 13.6682 19.5068 13.1281 19.8624L12 20.6053L10.8719 19.8624C10.3318 19.5068 9.69131 19.3352 9.04579 19.3731L7.69735 19.4524L7.09181 18.245Z"
  />,
];

const smallIcon = [
  <path
    key="1"
    d="M5.62729 9.88925H4.58624L3.04702 7.53818V9.88925H2V6.11093H3.04702L4.58325 8.462V7.28646V6.11093H5.62729V9.88925Z"
  />,
  <path
    key="2"
    d="M9.17863 8.28814H7.53203V9.1886H9.47692V9.88925H6.485V6.11093H9.48289V6.81417H7.53203V7.61084H9.17863V8.28814Z"
  />,
  <path
    key="3"
    d="M13.4638 8.48017L13.9619 6.11093H15L14.0783 9.88925H12.9925L12.4108 7.7354L11.841 9.88925H10.7582L9.8335 6.11093H10.8746L11.3727 8.48017L11.9693 6.11093H12.8582L13.4638 8.48017Z"
  />,
  <path
    key="4"
    d="M7.4921 3.04892L8.19047 2.5811L8.88884 3.04892C9.22316 3.27288 9.61966 3.38095 10.0193 3.35704L10.854 3.3071L11.2289 4.06745C11.4083 4.43144 11.5469 4.66894 11.9048 4.85149H14.0714C14.0859 4.6003 13.9444 4.46348 13.7233 4.35067L12.6114 3.78345C12.4922 3.7226 12.3954 3.62418 12.3356 3.50285L11.778 2.37182C11.6671 2.1469 11.4352 2.01072 11.1883 2.02549L9.94658 2.09977C9.81338 2.10774 9.68121 2.07172 9.56977 1.99707L8.53094 1.30118C8.32435 1.16279 8.0566 1.16279 7.85001 1.30118L6.81117 1.99707C6.69973 2.07172 6.56757 2.10774 6.43437 2.09977L5.19266 2.02549C4.94573 2.01072 4.71385 2.1469 4.60296 2.37182L4.04535 3.50285C3.98553 3.62418 3.88878 3.7226 3.76951 3.78345L2.65765 4.35067C2.43654 4.46348 2.29499 4.6003 2.30952 4.85149H4.47618C4.834 4.66894 4.97262 4.43144 5.15207 4.06745L5.52693 3.3071L6.36168 3.35704C6.76128 3.38095 7.15779 3.27287 7.4921 3.04892Z"
  />,
  <path
    key="5"
    d="M5.15207 11.9326C4.97262 11.5686 4.834 11.3312 4.47618 11.1487H2.30952C2.29499 11.3999 2.43654 11.5366 2.65765 11.6494L3.76951 12.2166C3.88878 12.2775 3.98553 12.3759 4.04535 12.4972L4.60296 13.6282C4.71385 13.8532 4.94573 13.9894 5.19266 13.9746L6.43437 13.9003C6.56757 13.8923 6.69973 13.9284 6.81117 14.003L7.85001 14.6989C8.0566 14.8373 8.32435 14.8373 8.53094 14.6989L9.56977 14.003C9.68121 13.9284 9.81338 13.8923 9.94658 13.9003L11.1883 13.9746C11.4352 13.9894 11.6671 13.8532 11.778 13.6282L12.3356 12.4972C12.3954 12.3759 12.4922 12.2775 12.6114 12.2166L13.7233 11.6494C13.9444 11.5366 14.0859 11.3999 14.0714 11.1487H11.9048C11.5469 11.3312 11.4083 11.5686 11.2289 11.9326L10.854 12.693L10.0193 12.643C9.61966 12.6191 9.22316 12.7272 8.88884 12.9511L8.19047 13.419L7.4921 12.9511C7.15778 12.7272 6.76128 12.6191 6.36168 12.643L5.52693 12.693L5.15207 11.9326Z"
  />,
];

export const NewBadgeIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="NewBadge" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
